/***
 * The typescript settings are not setup to support 2021 Errors with cause this is a helper
 */
export class ErrorWithCause extends Error {
    constructor(message: string, opts?: { cause?: Error }) {
        // @ts-ignore
        super(message, opts);
    }
}
